// extracted by mini-css-extract-plugin
export default {"container":"PatientStatus_container__JChF+","micIcon":"PatientStatus_micIcon__aNWFs","videoIcon":"PatientStatus_videoIcon__eeRY3"};